export const ExternalRepositoryPartial = `
... on ExternalRepository {
    name
}
`;
